export default __webpack_public_path__ + "static/media/2.9cfa1be3.png";